import React from "react";

import { CloseOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";
import Modal from "antd/es/modal/Modal";

import "./ReleaseTestResultsModal.css";
import "./SampleTestResultTable.css";

const modalTooltipContainer = () => document.body;

function TruncatedChip({ className, text }) {
  const label = (text ?? "").toString().trim() || "-";
  return (
    <Tooltip
      title={label}
      placement="top"
      classNames={{ root: "SampleTestResultTable__InvestigationTooltip" }}
      getPopupContainer={modalTooltipContainer}
    >
      <span className={className}>{label}</span>
    </Tooltip>
  );
}

export default function ReleaseTestResultsModal({
  testItem,
  loading,
  onCancel,
  onConfirm,
}) {
  if (!testItem) {
    return null;
  }

  const resultText = (testItem.result || "-").toString();

  return (
    <Modal
      open
      maskClosable={false}
      closable={false}
      centered
      footer={null}
      wrapClassName="ReleaseTestResultsModal"
      className="ReleaseTestResultsModal"
      width="520px"
    >
      <div className="ReleaseTestResultsModal__Header">
        <span className="ReleaseTestResultsModal__Title">Release these Test Results</span>
        <Button
          type="text"
          icon={<CloseOutlined />}
          className="ReleaseTestResultsModal__Close"
          aria-label="Close"
          disabled={loading}
          onClick={onCancel}
        />
      </div>

      <div className="ReleaseTestResultsModal__Body">
        <p className="ReleaseTestResultsModal__Lead">
          Following test will be released to COA
        </p>

        <div className="ReleaseTestResultsModal__Chips">
          <TruncatedChip
            className="ReleaseTestResultsModal__TestChip"
            text={testItem.test}
          />
          <TruncatedChip
            className="ReleaseTestResultsModal__SpecChip"
            text={testItem.specs || "-"}
          />
        </div>

        <div className="ReleaseTestResultsModal__Results">
          <div className="ReleaseTestResultsModal__ResultRow">
            <span className="ReleaseTestResultsModal__ResultLabel">Result</span>
            <Tooltip
              title={resultText}
              placement="top"
              classNames={{ root: "SampleTestResultTable__InvestigationTooltip" }}
              getPopupContainer={modalTooltipContainer}
            >
              <span className="ReleaseTestResultsModal__ResultValue">{resultText}</span>
            </Tooltip>
          </div>
        </div>
      </div>

      <div className="ReleaseTestResultsModal__Footer">
        <div className="ReleaseTestResultsModal__FooterActions">
          <Button
            type="default"
            className="ReleaseTestResultsModal__CancelBtn"
            onClick={onCancel}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            type="primary"
            className="ReleaseTestResultsModal__ConfirmBtn"
            loading={loading}
            onClick={onConfirm}
          >
            Release Results
          </Button>
        </div>
      </div>
    </Modal>
  );
}
